import determineSentencePartIsPassive from "./determineSentencePartIsPassive.js";
import getParticiples from "./getParticiples.js";

// Imports specific for German.
import auxiliariesGermanFactory from "../../german/passiveVoice/auxiliaries.js";
const auxiliariesGerman = auxiliariesGermanFactory().allAuxiliaries;
import getParticiplesGerman from "../../german/passiveVoice/getParticiples.js";

// Imports specific for Dutch.
import auxiliariesDutchFactory from "../../dutch/passiveVoice/auxiliaries.js";
const auxiliariesDutch = auxiliariesDutchFactory();

// Imports specific for Polish.
import auxiliariesPolishFactory from "../../polish/passiveVoice/auxiliaries.js";
const auxiliariesPolish = auxiliariesPolishFactory();

// Imports specific for Hungarian.
import getParticiplesHungarian from "../../hungarian/passiveVoice/getParticiples.js";
import auxiliariesHungarianFactory from "../../hungarian/passiveVoice/auxiliaries.js";
const auxiliariesHungarian = auxiliariesHungarianFactory().allAuxiliaries;

// The language-specific auxiliaries.
const languageVariables = {
	de: {
		auxiliaries: auxiliariesGerman,
	},
	nl: {
		auxiliaries: auxiliariesDutch,
	},
	pl: {
		auxiliaries: auxiliariesPolish,
	},
	hu: {
		auxiliaries: auxiliariesHungarian,
	},
};

/**
 * Determines whether a sentence part is passive.
 *
 * @param {string}  sentencePartText        The sentence part to determine voice for.
 * @param {Array}   sentencePartAuxiliaries A list with auxiliaries in this sentence part.
 * @param {string}  language                The language of the sentence part.

 * @returns {boolean} Returns true if passive, otherwise returns false.
 */
export default function( sentencePartText, sentencePartAuxiliaries, language ) {
	let participles = [];
	// For German, Dutch, Hungarian, and Polish, this path is taken in order to ensure that sentence parts without auxiliaries are not set to passive.
	if ( language === "de" || language === "nl" || language === "pl" || language === "hu" ) {
		// Return false if there are no auxiliaries in the sentence part.
		if ( ! sentencePartAuxiliaries.some( auxiliary => languageVariables[ language ].auxiliaries.includes( auxiliary ) ) ) {
			return false;
		}
		// For German, we use a separate function to get participles.
		if ( language === "de" ) {
			participles = getParticiplesGerman( sentencePartText, sentencePartAuxiliaries, language );
		}
		// For Dutch and Polish, we use the same function as for other languages.
		if ( language === "nl" || language === "pl" ) {
			participles = getParticiples( sentencePartText, sentencePartAuxiliaries, language );
		}
		if ( language === "hu" ) {
			participles = getParticiplesHungarian( sentencePartText, sentencePartAuxiliaries, language );
		}
	} else {
		participles = getParticiples( sentencePartText, sentencePartAuxiliaries, language );
	}

	return determineSentencePartIsPassive( participles );
}
